import "./theme.css"
const configTheme = {
  init: () => {
    window.document.body.classList.add("theme-qk2025")
    var elem = document.body
    var canvas = document.createElement("canvas")
    var ctx = canvas.getContext("2d")
    canvas.style.userSelect = "none"
    canvas.style.pointerEvents = "none"
    canvas.style.zIndex = 99999
    canvas.style.position = "fixed"
    canvas.style.left = canvas.style.top = "0"
    // canvas.style.width = "100vw"
    // canvas.style.height = "100vh"
    var width = elem.clientWidth || window.innerWidth
    var height = elem.clientHeight || window.innerHeight
    var active = false
    function onResize() {
      width = elem.clientWidth || window.innerWidth
      height = elem.clientHeight || window.innerHeight
      canvas.width = width
      canvas.height = height
      if (elem.clientWidth < window.innerWidth) {
        canvas.width = window.innerWidth
      }
      ctx.fillStyle = "#FFF"

      var wasActive = active
      active = width > 700

      if (!wasActive && active) {
        requestAnimationFrame(loop)
      }
    }

    //Start
    const DPR = Math.max(1, Math.min(2, window.devicePixelRatio || 1))
    const balloons = []
    let t0 = performance.now()
    function rand(a, b) {
      return a + Math.random() * (b - a)
    }
    function randInt(a, b) {
      return Math.floor(rand(a, b + 1))
    }
    function clamp(v, a, b) {
      return Math.max(a, Math.min(b, v))
    }

    class Balloon {
      constructor(x, y, size) {
        this.x = x // vị trí (CSS px)
        this.y = y
        this.size = size // đường kính thân bóng (px)
        this.knot = size * 0.08
        this.stringLen = rand(size * 1.1, size * 1.6)

        this.vx = rand(-0.15, 0.15) // trôi ngang nhẹ
        this.vy = rand(-0.0001, -0.0002) // trước là -0.9 đến -1.6           // bay lên
        this.ax = 0
        this.ay = rand(-0.0001, -0.0002) // lực nổi nhẹ dần

        this.life = rand(3200, 5200) // ms
        this.birth = performance.now()
        this.swingSeed = Math.random() * 1000

        // hơi méo cho tự nhiên
        this.ellipseRatio = rand(1.05, 1.25)
        this.starScale = rand(0.42, 0.52) // tỉ lệ ngôi sao so với bán kính
        this.rotation = rand(-0.1, 0.1) // nghiêng nhẹ
      }

      get age() {
        return performance.now() - this.birth
      }
      get alive() {
        return this.age < this.life && this.y + this.size > -50
      }

      update(dt) {
        this.vx += this.ax * dt
        this.vy += this.ay * dt

        // lắc lư rất nhẹ theo gió
        const wind = Math.sin((this.age + this.swingSeed) * 0.003) * 0.08
        this.x += (this.vx + wind) * dt
        this.y += this.vy * dt
      }

      draw(ctx) {
        const s = this.size
        const r = s * 0.5
        const w = s * 0.98 // chiều ngang
        const h = s * this.ellipseRatio // chiều dọc

        // opacity theo tuổi, mờ dần 25% cuối đời
        const fadeStart = 0.75 * this.life
        const alpha =
          this.age < fadeStart
            ? 1
            : clamp(1 - (this.age - fadeStart) / (this.life - fadeStart), 0, 1)

        ctx.save()
        ctx.globalAlpha = alpha

        // vẽ dây
        this.drawString(ctx, w, h)

        // vẽ thân bóng (nền đỏ)
        ctx.translate(this.x, this.y)
        ctx.rotate(this.rotation)
        const topY = -h * 0.52,
          bottomY = h * 0.48

        ctx.beginPath()
        ctx.ellipse(0, 0, w * 0.5, h * 0.5, 0, 0, Math.PI * 2)
        ctx.fillStyle = "#d60000" // đỏ cờ
        ctx.fill()

        // nút buộc
        ctx.beginPath()
        ctx.moveTo(0, bottomY)
        ctx.lineTo(-this.knot * 0.7, bottomY + this.knot)
        ctx.lineTo(this.knot * 0.7, bottomY + this.knot)
        ctx.closePath()
        ctx.fill()

        // highlight nhẹ
        const grd = ctx.createRadialGradient(
          -w * 0.2,
          topY * 0.6,
          2,
          -w * 0.2,
          topY * 0.6,
          w * 0.8
        )
        grd.addColorStop(0, "rgba(255,255,255,0.35)")
        grd.addColorStop(1, "rgba(255,255,255,0)")
        ctx.fillStyle = grd
        ctx.beginPath()
        ctx.ellipse(0, 0, w * 0.5, h * 0.5, 0, 0, Math.PI * 2)
        ctx.fill()

        // ngôi sao vàng ở giữa
        this.drawStar(
          ctx,
          0,
          0,
          r * this.starScale,
          r * this.starScale * 0.45,
          5,
          "#ffd400"
        )

        ctx.restore()
      }

      drawString(ctx, w, h) {
        ctx.save()
        const baseX = this.x
        const baseY = this.y + h * 0.5 + this.knot
        const len = this.stringLen

        // cong nhẹ, lắc theo thời gian
        const t = (this.age + this.swingSeed) * 0.0025
        const sway = Math.sin(t) * (w * 0.25)
        const sway2 = Math.sin(t + 0.8) * (w * 0.18)

        const cp1x = baseX - sway
        const cp1y = baseY + len * 0.33
        const cp2x = baseX + sway2
        const cp2y = baseY + len * 0.66
        const endx = baseX + Math.sin(t * 0.9) * (w * 0.12)
        const endy = baseY + len

        ctx.beginPath()
        ctx.moveTo(baseX, baseY)
        ctx.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, endx, endy)
        ctx.lineWidth = 1.2
        ctx.strokeStyle = "rgba(120,120,120,0.35)"
        ctx.stroke()
        ctx.restore()
      }

      drawStar(ctx, cx, cy, outerR, innerR, spikes, color) {
        let rot = -Math.PI / 2 // hướng mũi lên
        const step = Math.PI / spikes
        ctx.beginPath()
        for (let i = 0; i < spikes * 2; i++) {
          const r = i % 2 === 0 ? outerR : innerR
          const x = cx + Math.cos(rot) * r
          const y = cy + Math.sin(rot) * r
          i === 0 ? ctx.moveTo(x, y) : ctx.lineTo(x, y)
          rot += step
        }
        ctx.closePath()
        ctx.fillStyle = color
        ctx.fill()
      }
    }

    const particles = []
    const colors = [
      "#FFEE9E",
      "#FFD7A8",
      "#FF9DB4",
      "#B5D0FF",
      "#C7FFEA",
      "#EEC8FF",
    ]
    // draw a 5-point star centered at 0,0 with outer radius r
    function drawStarPath(ctx, r) {
      const n = 5
      const step = Math.PI / n
      ctx.beginPath()
      for (let i = 0; i < 2 * n; i++) {
        const radius = i % 2 === 0 ? r : r * 0.45
        const angle = i * step - Math.PI / 2
        const x = Math.cos(angle) * radius
        const y = Math.sin(angle) * radius
        if (i === 0) ctx.moveTo(x, y)
        else ctx.lineTo(x, y)
      }
      ctx.closePath()
    }
    class Star {
      constructor(x, y) {
        this.x = x
        this.y = y
        const speed = rand(90, 320) // px per second
        const angle =
          rand(-Math.PI / 1.8, Math.PI / 1.8) +
          rand(-0.5, 0.5) +
          (Math.random() < 0.5 ? -Math.PI / 2 : -Math.PI / 2)
        this.vx = Math.cos(angle) * speed
        this.vy = Math.sin(angle) * speed - rand(40, 120)
        this.size = rand(5, 10)
        this.rotation = rand(0, Math.PI * 2)
        this.vr = rand(-3, 3) // deg per sec (radians)
        this.life = rand(0.9, 1.8) // seconds
        this.age = 0
        this.color = colors[Math.floor(Math.random() * colors.length)]
        this.twinkleSpeed = rand(6, 14)
        this.fadeDelay = rand(0.0, 0.25)
        this.gravity = 200 // px/s^2 downward
        this.airDrag = 0.98
        this.rotationSpeed = rand(-2, 2)
        // sparkle small tail particles spawn rate
        this._lastTail = 0
      }

      update(dt) {
        this.age += dt
        // physics
        this.vy += this.gravity * dt
        this.vx *= Math.pow(this.airDrag, dt * 60)
        this.vy *= Math.pow(this.airDrag, dt * 60)
        this.x += this.vx * dt
        this.y += this.vy * dt
        this.rotation += this.rotationSpeed * dt
        // spawn small sparkles
        this._lastTail += dt
        if (this._lastTail > 0.02) {
          this._lastTail = 0
          if (Math.random() < 0.6) {
            particles.push(
              new Spark(
                this.x - this.vx * 0.02,
                this.y - this.vy * 0.02,
                this.color
              )
            )
          }
        }
      }

      draw(ctx) {
        const t = this.age
        const lifeRatio = Math.max(0, 1 - t / this.life)
        // fade after delay
        let alpha = lifeRatio
        if (t < this.fadeDelay) alpha = 1
        // twinkle: oscillate scale a bit
        const tw = 0.85 + 0.25 * Math.abs(Math.sin(t * this.twinkleSpeed))
        ctx.save()
        ctx.translate(this.x, this.y)
        ctx.rotate(this.rotation)
        ctx.globalAlpha = Math.min(1, alpha)
        // glow
        ctx.shadowBlur = 12 * (this.size / 12)
        ctx.shadowColor = this.color
        ctx.fillStyle = this.color
        drawStarPath(ctx, this.size * tw)
        ctx.fill()
        // add a tiny white core
        ctx.shadowBlur = 0
        ctx.fillStyle = "rgba(255,255,255," + Math.min(0.9, 0.8 * alpha) + ")"
        drawStarPath(ctx, this.size * 0.38)
        ctx.fill()
        ctx.restore()
      }

      isDead() {
        return this.age > this.life
      }
    }

    // small sparkle particle for trailing
    class Spark {
      constructor(x, y, color) {
        this.x = x + rand(-4, 4)
        this.y = y + rand(-4, 4)
        this.vx = rand(-40, 40)
        this.vy = rand(-40, 40)
        this.life = rand(0.25, 0.6)
        this.age = 0
        this.size = rand(1, 3)
        this.color = color
      }
      update(dt) {
        this.age += dt
        this.vy += 120 * dt
        this.x += this.vx * dt
        this.y += this.vy * dt
      }
      draw(ctx) {
        const a = Math.max(0, 1 - this.age / this.life)
        if (a <= 0) return
        ctx.save()
        ctx.globalAlpha = a
        ctx.fillStyle = this.color
        ctx.fillRect(
          this.x - this.size / 2,
          this.y - this.size / 2,
          this.size,
          this.size
        )
        ctx.restore()
      }
      isDead() {
        return this.age > this.life
      }
    }

    // spawn function
    function spawnStars(x, y, count = 12) {
      for (let i = 0; i < count; i++) {
        particles.push(new Star(x, y))
      }
      for (let i = 0; i < count - 6; i++) {
        particles.push(
          new Spark(
            x + rand(-6, 6),
            y + rand(-6, 6),
            colors[Math.floor(Math.random() * colors.length)]
          )
        )
      }
    }

    function spawnBalloons(x, y, count) {
      for (let i = 0; i < count; i++) {
        const size = rand(20, 50)
        const b = new Balloon(x + rand(-8, 8), y + rand(-8, 8), size)
        balloons.push(b)
      }
    }
    document.body.addEventListener("pointerdown", e => {
      if (e.target === canvas) return
      const x = e.clientX
      const y = e.clientY
      spawnBalloons(x, y, randInt(2, 3))
      //
      spawnStars(x, y, 10)
    })

    function loop(now) {
      // clear
      ctx.clearRect(0, 0, canvas.clientWidth, canvas.clientHeight)

      // update particles
      // const dtStar = Math.min(0.05, (now - t0) / 1000)
      const dtStar = 0.05
      for (let i = particles.length - 1; i >= 0; i--) {
        const p = particles[i]
        p.update(dtStar)
        if (p.isDead()) particles.splice(i, 1)
      }
      // draw - draw larger stars later for depth
      for (let p of particles) p.draw(ctx)

      const dt = Math.min(32, now - t0) // ms, clamp để mượt
      // update + draw
      for (let i = balloons.length - 1; i >= 0; i--) {
        const b = balloons[i]
        b.update(dt)
        b.draw(ctx)
        if (!b.alive) balloons.splice(i, 1)
      }

      t0 = now
      requestAnimationFrame(loop)
    }
    requestAnimationFrame(loop)

    //

    window.addEventListener("resize", onResize, false)
    elem.appendChild(canvas)

    document.addEventListener("DOMContentLoaded", function () {
      onResize()
    })
  },
}
export default configTheme
